// ============================================================================
// BOQ — lightweight fuzzy text matching (client-side)
// ============================================================================
// Trigram Dice-coefficient similarity for ranking imported sample-BOQ lines
// against library item descriptions. Kept client-side (no pg_trgm round-trip)
// since the whole library is already loaded for the import; swap to a server
// RPC if the library grows large.
// ============================================================================

const normalize = (s) => (s || '')
  .toLowerCase()
  .replace(/[^a-z0-9 ]+/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

// Set of 3-char shingles over the space-padded string.
function trigrams(s) {
  const padded = `  ${s} `;
  const set = new Set();
  for (let i = 0; i < padded.length - 2; i++) set.add(padded.slice(i, i + 3));
  return set;
}

// Dice coefficient of two trigram sets: 0..1.
export function similarity(a, b) {
  const na = normalize(a);
  const nb = normalize(b);
  if (!na || !nb) return 0;
  if (na === nb) return 1;
  const ta = trigrams(na);
  const tb = trigrams(nb);
  let inter = 0;
  ta.forEach((t) => { if (tb.has(t)) inter += 1; });
  return (2 * inter) / (ta.size + tb.size);
}

// Rank library versions against a query description. Returns
// [{ version, score }] sorted best-first, limited. A matching unit gives a
// small boost so otherwise-equal candidates with the right unit win.
export function rankVersions(query, versions, { limit = 6, unit = '' } = {}) {
  const u = normalize(unit);
  const scored = (versions || []).map((v) => {
    let score = similarity(query, v.shortDescription);
    if (u && normalize(v.unit) === u) score = Math.min(1, score + 0.05);
    return { version: v, score };
  });
  scored.sort((a, b) => b.score - a.score);
  return scored.slice(0, limit);
}
